<template>
<div class="chapter">
<div class="inner_page">
<div class="acknowPage">
<a id="title1"><h1 class="title">ACKNOWLEDGMENTS</h1>
<p class="p"><span>All of the postcards used in this book are from the collection of Mr. Rick Frazee, unless otherwise indicated. Most of the postcard messages I’ve quoted are also from his collection, though a few come from the files of the Winter Park Public Library and from cards in my own tiny collection. My great thanks go to the following people: Gertrude Laframboise, Department of College Archives and Special Collections, Olin Library, Rollins College; the Orange County Regional History Center; the Florida State Archives; Diana Zimmerman of the Winter Park Public Library; and Peggy Strong, Carol Card, Wanda Salerno, and Bud Sowers for sharing with me their memories. I am aware that a book similar to this one is being researched about West Winter Park, and because of that I have not included the story of West Winter Park in this book. The sad legacy of segregation is that vintage postcards and photographs of West Winter Park are scarce. Those that are presently being catalogued will, I hope, be used in the upcoming book. Finally, this book is dedicated to:
</span></p>
<div class="blocktext"><p class="p-c-br"><span>Mr. Rick Frazee, Mr. Dean Padgett, <br/>and <br/>the Winter Park Public Library, <br/>for collecting and conserving our history.</span></p></div>
<div class="illustype_image_text"><div class="image_text" style="width:77%"><img alt="e9781439629895_i0004.jpg" src="images/e9781439629895_i0004.jpg"/></div>
<div class="caption"><p class="p"><span>At the turn of the 20th century, Winter Park had two brass bands. The one photographed for this postcard may have just played for a Fourth of July event, since the shirtsleeves on band members suggest the steamy summer season. The members are, from left to right, Walter Schultz, Arthur Schultz, Raymond Ward, Gus Moreman, Ray Trovillion, Joe Ahik, Harley Ward, Ed Favor, Harold Fly, Mr. Searcy, Harry R. Newell, Leland Chubb, and Thomas Henkel. (Courtesy of the Winter Park Public Library.)</span></p></div></div></a></div><a id="title1">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781439629895_ack01.vue?823589ba